/**
 * Đơn vị tính đến triệu đồng
 */
export default {
  One: 0,
  Thousand: 1,
  Million: 2
};